export interface WordPlacement {
  word: string;
  startRow: number;
  startCol: number;
  direction: "across" | "down";
}

export type { Difficulty } from "@griddle/generator";
export { DIFFICULTIES, DIFFICULTY_LABELS, getDifficultyForDate, DIFFICULTY_START_DATE } from "@griddle/generator";
import type { Difficulty } from "@griddle/generator";

export const DIFFICULTY_COLORS: Record<Difficulty, string> = {
  chill: "#4ade80",
  easy: "#86efac",
  breezy: "#fde047",
  medium: "#fbbf24",
  tricky: "#fb923c",
  hard: "#f87171",
  brutal: "#dc2626",
};

export const DIFFICULTY_EMOJI: Record<Difficulty, string> = {
  chill: "\u{1F60C}",   // 😌
  easy: "\u{1F60A}",    // 😊
  breezy: "\u{1F642}",  // 🙂
  medium: "\u{1F610}",  // 😐
  tricky: "\u{1F62C}",  // 😬
  hard: "\u{1F630}",    // 😰
  brutal: "\u{1F631}",  // 😱
};

/**
 * API-facing puzzle type (intentionally omits `solution` — the API strips it
 * before sending to the client). Do not import from @griddle/generator.
 */
export interface Puzzle {
  date: string;
  size: "7x7" | "9x9";
  difficulty?: Difficulty;
  grid: (string | null)[][];
  words: WordPlacement[];
  maxSwaps: number;
}

export type CellColor = "green" | "yellow" | "grey" | "empty";

export interface CellState {
  letter: string | null;
  color: CellColor;
  isSelected: boolean;
  isLocked: boolean;
  row: number;
  col: number;
}

export interface PuzzleResult {
  solved: boolean;
  swapsUsed: number;
  maxSwaps: number;
  stars: number;
  elapsedMs: number;
  focusedMs?: number;
  size: string;
  overLimit: boolean;
  attempts: number;
  firstTry: boolean;
  completedAtDate?: string;
  completedAtMs?: number;
}

export interface LocalProgress {
  [key: string]: PuzzleResult;
}

export type LeaderboardView = "time" | "stars" | "winrate" | "streak" | "wins";

export interface LeaderboardEntry {
  rank: number;
  userId: string;
  leaderboardName: string;
  avatarUrl: string | null;
  elapsedMs?: number;
  stars?: number;
  swapsUsed?: number;
  attempts?: number;
  winPercent?: number;
  avgStars?: number;
  currentPlayStreak?: number;
  longestPlayStreak?: number;
  currentWinStreak?: number;
  longestWinStreak?: number;
}

export interface LeaderboardResponse {
  entries: LeaderboardEntry[];
  userRank: number | null;
  userEntry: LeaderboardEntry | null;
}
